import { literal, object, type InferOutput } from 'valibot'
import { Engine } from '../../../../engine/Engine.type'
import type { ActionLog } from '../../ActionLog.type'
import { ActionType } from '../ActionType'

export const EndRoundActionSchema = object({
  type: literal(ActionType.Game.EndRound),
})

export type EndRoundAction = InferOutput<typeof EndRoundActionSchema>

export function createEndRoundAction(): EndRoundAction {
  return {
    type: ActionType.Game.EndRound,
  }
}

export async function handleEndRoundAction(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  engine: Engine,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  action: EndRoundAction,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  actionLog: ActionLog
): Promise<void> {
  // placeholder for future events hooks
}
